export class Pagination {
  public currentPage: number;
  public maxPage: number;
  public totalCount: number;
  public pageSize: number;
  public pageLowerIndex: number;
  public pageUpperIndex: number;

  public firstPageToShow: number;
  public lastPageToShow: number;

  public numberOfPagesToShow = 10;

  constructor(currentPage: number, totalCount: number, pageSize: number) {
    this.currentPage = currentPage;
    this.totalCount = totalCount;
    this.pageSize = pageSize;

    this.maxPage = Math.ceil(totalCount / pageSize) - 1;

    this.pageUpperIndex = Math.min((currentPage + 1) * pageSize, totalCount);
    this.pageLowerIndex = Math.min(this.pageUpperIndex, currentPage * pageSize + 1);

    this.firstPageToShow = Math.max(currentPage - this.numberOfPagesToShow / 2, 0);
    this.lastPageToShow = Math.min(this.firstPageToShow + this.numberOfPagesToShow, this.maxPage);
  }
}
